import React from 'react';
import styled from 'styled-components';
import { WeeklyUserCountPayload } from '../../../api/serviceAnalytics/userAnalysis/type';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import StackedColumnsChart from '../../Molecule/Chart/StackedColumnsChart';
import Spinner from '../../Molecule/Spinner';

const Component = styled.div`
  width: 100%;
  height: 497px;
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 24px 24px 40px 24px;
  border-radius: 16px;
`;

const Body = styled.div`
  flex: 1;
  width: 100%;
  margin-top: 40px;
`;

interface StackedColumnsChartCardProps {
  Data: WeeklyUserCountPayload | null;
  bar1Label: string;
  bar2Label: string;
  loading: boolean;
}

const StackedColumnsChartCard = ({
  Data,
  bar1Label,
  bar2Label,
  loading,
}: StackedColumnsChartCardProps) => {
  return (
    <Component>
      <Header>
        <Title title="요일별 그래프" />
      </Header>
      <Body>
        {loading ? (
          <Spinner />
        ) : (
          <StackedColumnsChart
            Data={Data}
            bar1Label={bar1Label}
            bar2Label={bar2Label}
          />
        )}
      </Body>
    </Component>
  );
};

export default StackedColumnsChartCard;
